// https://api.holdstation.com/api/coins/worldcoin-wld

import useSWR from 'swr';
const URL = 'https://api.holdstation.com/api/coins/worldcoin-wld';
async function call(url: string) {
    const res = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}

export function useGetRateWld() {
    const data = useSWR(URL, call, {
        shouldRetryOnError: false,
    });

    return {
        ...data,
        quoteRate: data.data?.market_data?.current_price?.usd ?? 0,
    };
}
